import { Component, Prop } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import MixinChart from '@/plugins/podolib/services/helper/mixins/chart';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';

export type TChart = {
  created(): void;
};

@Component
export default class MixinChartRaw extends MixinChart {
  @Prop({ required: true }) protected values!: TAcquisition['computed_data'];
  @Prop({ default: null })
  protected compareValues!: TAcquisition | TAcquisition['computed_data'];
  @Prop({ default: null }) protected isSelected!: boolean | null;
  @Prop(Boolean) protected comparison!: boolean;
  @Prop(Boolean) protected degradedActivity!: boolean;
  @Prop({ required: false }) protected patient!: TEntity<TPatient>;
  @Prop(Boolean) protected simple!: boolean;
}
